<template>
  <div>
    <CSPLoader v-if="loading" />
    <v-container v-else grid-list-lg class="touch-view-container">
      <v-toolbar short class="elevation-0">
        <v-toolbar-title class="mx-auto font-weight-regular">Update Attendee</v-toolbar-title>
      </v-toolbar>
      <v-card flat>
        <v-card-text>
          <v-layout row wrap>
            <v-flex xs12>
              <ImageBox :customerImage="true" owner="Employee" v-on:setImage="setImage" :imageURL="employee.imageURL"
                :images="getImages" />
            </v-flex>
            <v-flex xs12 md6>
              <v-text-field dense label="First Name" outlined type="text" v-model="employee.firstName"
                @focus="$event.target.select()" :error-messages="firstNameErrors"
                :hide-details="firstNameErrors.length === 0" @input="$v.employee.firstName.$touch()"></v-text-field>
            </v-flex>
            <v-flex xs12 md6>
              <v-text-field label="Last Name" dense hide-details outlined type="text" v-model="employee.lastName"
                @focus="$event.target.select()"></v-text-field>
            </v-flex>
            <v-flex xs12 md6>
              <v-text-field dense type="number" outlined hide-details v-model="employee.phoneNumber"
                label="Phone Number" @focus="$event.target.select()"></v-text-field>
            </v-flex>
            <v-flex xs12 md6>
              <v-text-field dense type="text" outlined hide-details v-model="employee.email" label="Email Address"
                @focus="$event.target.select()"></v-text-field>
            </v-flex>
            <v-flex md6 xs12>
              <v-select label="Select Department" :items="departments" v-model="employee.DepartmentId" item-text="name"
                item-value="id" hide-details outlined solo dense :loading="departments.length === 0"></v-select>
            </v-flex>
            <v-flex xs12 md6>

              <v-layout row>

                <v-flex xs8>
                  <v-text-field dense :background-color="`${employee.pinCode ? false : $style.inputBox.mandatory
                    }`" v-model="employee.pinCode" :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                    :type="showPassword ? 'number' : 'password'" label="Pin" autocomplete="false"
                    :hide-details="pinCodeErrors.length === 0" @focus="$event.target.select()"
                    :error-messages="pinCodeErrors" @input="$v.employee.pinCode.$touch()"
                    @click:append="showPassword = !showPassword" outlined readonly></v-text-field>
                </v-flex>
                <v-flex xs4>
                  <v-btn color="primary" @click.stop.prevent="setPinOpen" block>
                    Set Pin
                  </v-btn>
                </v-flex>

              </v-layout>
            </v-flex>
            <v-flex xs12>
              <v-row class="m-0 p-0" align-content="center" justify="space-around">
                <v-checkbox v-model="employee.metadata.timeClockLogin.admin"
                  v-if="employee.metadata && employee.metadata.timeClockLogin" label="Admin"></v-checkbox>

                <v-checkbox v-if="employee.metadata && employee.metadata.timeClockLogin"
                  v-model="employee.metadata.timeClockLogin.employee" label="Attendee"></v-checkbox>
              </v-row>
            </v-flex>

            <v-flex xs12 v-if="employee.metadata && employee.metadata.timeClockLogin.employee">
              <v-layout row>
                <v-flex xs8>
                  <div class="font-weight-medium">Full Day</div>
                  <p class="font-weight-light mb-0">
                    Attendee will receive pay according to day
                  </p>
                </v-flex>
                <v-flex xs4>
                  <v-switch class="mx-0 text-right" v-model="employee.metadata.timeClockLogin.fullDayEmployee
                    " color="teal"
                    :label="employee.metadata.timeClockLogin.fullDayEmployee ? 'Enabled' : 'Disabled'"></v-switch>
                </v-flex>
              </v-layout>
            </v-flex>

            <v-flex xs12 v-if="employee.metadata && employee.metadata.timeClockLogin.employee
              && !employee.metadata.timeClockLogin.fullDayEmployee
            ">
              <v-layout row wrap>
                <v-flex xs12 md6>
                  <v-text-field prefix="$" outlined type="number" dense hide-details v-model="employee.hourlyRate"
                    label="Hourly Rate" @focus="$event.target.select()"></v-text-field>
                </v-flex>
                <v-flex xs12 md6>
                  <v-text-field type="number" dense hide-details outlined
                    v-model="employee.metadata.timeClockLogin.workingHours" label="Daily Working Hours"
                    @focus="$event.target.select()" mask="phone"></v-text-field>
                </v-flex>
              </v-layout>

            </v-flex>

            <v-flex xs12 v-else-if="employee.metadata && employee.metadata.timeClockLogin.employee">

              <v-layout row wrap>
                <v-flex xs12 md4>
                  <v-text-field prefix="$" dense hide-details outlined type="number"
                    v-model="employee.metadata.timeClockLogin.fullDayRate" label="Rate Per Day"
                    @focus="$event.target.select()"></v-text-field>
                </v-flex>
                <v-flex xs12 md4>
                  <v-text-field type="number" dense hide-details outlined
                    v-model="employee.metadata.timeClockLogin.workingHours" label="Expected Hours in a day"
                    @focus="$event.target.select()" mask="phone"></v-text-field>
                </v-flex>
                <v-flex xs12 md4>
                  <v-text-field type="number" dense hide-details outlined
                    v-model="employee.metadata.timeClockLogin.halfDayHours"
                    label="How many hours do you consider as half day" @focus="$event.target.select()"
                    mask="phone"></v-text-field>
                </v-flex>
              </v-layout>

            </v-flex>

            <v-flex xs12>
              <v-layout row>
                <v-flex xs8>
                  <div class="font-weight-medium">Overtime</div>
                  <p class="font-weight-light mb-0">
                    Enable this feature if you like to pay overtime.
                  </p>
                </v-flex>
                <v-flex xs4>
                  <v-switch class="mx-0 text-right" v-model="employee.payOverTime
                    " color="teal" :label="employee.payOverTime ? 'Enabled' : 'Disabled'"></v-switch>
                </v-flex>
              </v-layout>
            </v-flex>

            <v-flex xs12 v-if="employee.payOverTime">
              <v-layout row wrap>
                <v-flex xs12 md6>
                  <v-text-field prefix="$" outlined type="number" dense hide-details v-model="employee.overTimeRate"
                    label="Overtime Rate" @focus="$event.target.select()"></v-text-field>
                </v-flex>
                <v-flex xs12 md6>
                  <v-text-field type="number" dense hide-details outlined v-model="employee.startOverTime"
                    label="Overtime Start After" @focus="$event.target.select()" mask="phone"></v-text-field>
                </v-flex>
              </v-layout>
            </v-flex>

          </v-layout>

          <v-layout column fill-height>

            <v-flex xs12 v-if="employee.metadata &&
              employee.metadata.timeClockLogin &&
              employee.metadata.timeClockLogin.access &&
              employee.metadata.timeClockLogin.admin">


              <div class="text-center"><strong>Panel Access</strong></div>

              <v-expansion-panels class="mt-4" focusable>
                <v-expansion-panel v-if="currentEmployee.owner">
                  <v-expansion-panel-header>Restrict View</v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-row class="mt-2">
                      <v-col>
                        <span class="font-weight-medium">View Attendee</span>
                        <p class="font-weight-light mb-0">
                          Only show attendee you want to show
                        </p>
                      </v-col>
                      <v-col class="shrink">
                        <v-switch class="mt-0 text-right" v-model="employee.metadata.timeClockLogin.access.onlyView
                          " color="teal" :label="employee.metadata.timeClockLogin.access.onlyView
                            ? 'Enabled'
                            : 'Disabled'
                            "></v-switch>
                      </v-col>
                    </v-row>
                    <div v-if="employee.metadata.timeClockLogin.access &&
                      employee.metadata.timeClockLogin.access.onlyView
                    ">
                      <v-divider></v-divider>
                      <v-card-text>
                        <v-list style="height: 200px; overflow: auto !important;">
                          <v-list-item-group v-model="employee.metadata.timeClockLogin.access.onlyViewEmployee"
                            multiple>
                            <template v-for="(item, i) in employees">
                              <v-list-item :key="`item-${i}`" :value="item.id"
                                active-class="deep-purple--text text--accent-4">
                                <template v-slot:default="{ active }"><v-list-item-action>
                                    <v-checkbox :input-value="active" color="deep-purple accent-4"></v-checkbox>
                                  </v-list-item-action>
                                  <v-list-item-content>
                                    <v-list-item-title v-text="item.name"></v-list-item-title>
                                  </v-list-item-content>
                                </template>
                              </v-list-item>
                            </template>
                          </v-list-item-group>
                        </v-list>
                      </v-card-text>
                    </div>

                  </v-expansion-panel-content>
                </v-expansion-panel>

                <v-expansion-panel>
                  <v-expansion-panel-header>Time Clock</v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-checkbox hide-details label="Add New Time" v-model="employee.metadata.timeClockLogin.access.timeClock.create
                      "></v-checkbox>
                    <v-checkbox hide-details class="mt-0" label="Edit Entry Time" v-model="employee.metadata.timeClockLogin.access.timeClock.edit
                      "></v-checkbox>
                    <v-checkbox hide-details class="mt-0" label="Delete Time Entry" v-model="employee.metadata.timeClockLogin.access.timeClock.delete
                      "></v-checkbox>
                    <v-checkbox hide-details class="mt-0" label="Clock In/Out From Home" v-model="employee.metadata.timeClockLogin.access.timeClock.inOut
                      "></v-checkbox>
                    <v-checkbox hide-details class="mt-0" label="Allow To Instant Clock In/Out From Home" v-model="employee.metadata.timeClockLogin.access.timeClock
                      .instant
                      "></v-checkbox>
                    <v-checkbox hide-details class="mt-0" label="Allow To instant Report Clock In/Out From Home"
                      v-model="employee.metadata.timeClockLogin.access.timeClock
                        .instantReport
                        "></v-checkbox>
                  </v-expansion-panel-content>
                </v-expansion-panel>

                <v-expansion-panel>
                  <v-expansion-panel-header>Pay</v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-checkbox hide-details label="Create Pay Slip" v-model="employee.metadata.timeClockLogin.access.pay.create
                      "></v-checkbox>
                    <v-checkbox hide-details class="mt-0" label="Delete Pay Slip" v-model="employee.metadata.timeClockLogin.access.pay.delete
                      "></v-checkbox>
                    <v-checkbox hide-details class="mt-0" label="Pay Pickup" v-model="employee.metadata.timeClockLogin.access.pay.pickup
                      "></v-checkbox>
                    <v-checkbox hide-details class="mt-0" label="Mark Pay Un-Pickup" v-model="employee.metadata.timeClockLogin.access.pay.markUnPickup
                      "></v-checkbox>
                  </v-expansion-panel-content>
                </v-expansion-panel>

                <v-expansion-panel>
                  <v-expansion-panel-header>Employee</v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-checkbox hide-details label="Add New Employee" v-model="employee.metadata.timeClockLogin.access.employee.create
                      "></v-checkbox>
                    <v-checkbox hide-details class="mt-0" label="Edit Employee" v-model="employee.metadata.timeClockLogin.access.employee.edit
                      "></v-checkbox>
                    <v-checkbox hide-details class="mt-0" label="Delete Employee" v-model="employee.metadata.timeClockLogin.access.employee.delete
                      "></v-checkbox>
                    <v-checkbox hide-details class="mt-0" label="Allow To Create Admin" v-model="employee.metadata.timeClockLogin.access.employee
                      .createAdmin
                      "></v-checkbox>
                    <v-checkbox hide-details class="mt-0" label="View Profile" v-model="employee.metadata.timeClockLogin.access.employee
                      .viewProfile
                      "></v-checkbox>
                  </v-expansion-panel-content>
                </v-expansion-panel>

                <v-expansion-panel>
                  <v-expansion-panel-header>Report</v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-checkbox hide-details label="View Report" v-model="employee.metadata.timeClockLogin.access.report.view
                      "></v-checkbox>
                    <v-checkbox hide-details class="mt-0" label="Show Pay" v-model="employee.metadata.timeClockLogin.access.report.showPay
                      "></v-checkbox>
                    <v-checkbox hide-details class="mt-0" label="Show Working Hours" v-model="employee.metadata.timeClockLogin.access.report.showHours
                      "></v-checkbox>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </v-flex>

            <v-flex xs12>
              <div class="text-center"><strong>Restriction</strong></div>
              <v-card outlined class="mt-5">
                <v-card-text>
                  <v-row align="center">
                    <v-col>
                      <span class="font-weight-medium">Restrict Time</span>
                      <p class="font-weight-light mb-0">
                        Restrict time for attendee according to days
                      </p>
                    </v-col>
                    <v-col class="shrink">
                      <v-switch class="mx-0 text-right" v-model="employee.restrictedTime
                        " color="teal" :label="employee.restrictedTime ? 'Enabled' : 'Disabled'"></v-switch>
                    </v-col>
                  </v-row>
                  <v-row align="center" v-if="employee.restrictedTime">
                    <v-col cols="10">
                      <span class="font-weight-medium">Clock-In Time Configuration</span>
                      <p class="font-weight-light mb-0">
                        This feature allows you to configure clock-in times with two options:
                        “Firm Time” and “Strict Time.” With “Firm Time,” users can clock in within a flexible window
                        around the
                        scheduled time, allowing for minor variations. In contrast, with “Strict Time,” users can clock
                        in at any
                        time within
                        the flexible window, but their clock-in will be recorded as the set schedule time, regardless of
                        the actual
                        clock-in time. This ensures that clock-ins are consistently logged according to the set schedule
                        time.
                      </p>
                    </v-col>
                    <v-col cols="2">
                      <v-switch class="mx-0 text-right" v-model="employee.clockInConfiguration
                        " color="teal" :label="employee.clockInConfiguration ? 'Strict Time' : 'Firm Time'"></v-switch>
                    </v-col>
                  </v-row>
                  <v-row align="center" v-if="employee.restrictedTime">
                    <v-col>
                      <span class="font-weight-medium">Flexible Clock-In Window</span>
                      <p class="font-weight-light mb-0">Set a grace period in minutes to allow employees to clock in up
                        to set minutes before their scheduled start time. Simply enter your desired grace period,
                        and the system will automatically base clock-in eligibility on this duration,
                        providing a more relaxed and efficient time-tracking experience for your team.</p>
                    </v-col>
                    <v-col cols="12">
                      <v-text-field dense suffix="Minutes" type="number" outlined
                        v-model="employee.metadata.timeClockLogin.clockInGracePeriod" mask="phone"></v-text-field>

                    </v-col>
                  </v-row>



                  <v-layout row wrap class="mt-3" v-if="employee.restrictedTime">
                    <v-flex v-for="item in employee.timeRestrictions" :key="item.id" xs12 sm6 md4 lg3>
                      <v-card outlined>
                        <v-card-title primary-title>
                          <v-layout row wrap>
                            <v-flex>
                              {{ item.id }}
                            </v-flex>
                            <v-spacer></v-spacer>
                            <v-flex shrink>
                              <v-btn icon @click="CopyOnAll(item.id)">
                                <v-icon>mdi-content-copy</v-icon>
                              </v-btn>
                            </v-flex>
                          </v-layout>
                        </v-card-title>
                        <v-card-text>
                          <div>
                            <div>In</div>
                            <DateTimeTextField :hideCalenderIcon="true" :clearable="true" :noDefaultTime="true"
                              :label="'Time'" v-model="item.startTime" :showCopyPasteIcon="true"
                              :initTime="item.startTime" class="al-r pt-1" :ampmFormat="true" :hideDate="true" />
                          </div>
                          <div>
                            <div>Out</div>
                            <DateTimeTextField :hideCalenderIcon="true" :showCopyPasteIcon="true" :clearable="true"
                              :noDefaultTime="true" :label="'Time'" v-model="item.endTime" :initTime="item.endTime"
                              class="al-r pt-1" :ampmFormat="true" :hideDate="true" />
                          </div>
                        </v-card-text>
                      </v-card>
                      <!-- <div class="text-center font-weight-bold">{{ item.id }}</div>
                      <div>
                        <div>In</div>
                        <DateTimeTextField :hideCalenderIcon="true" :clearable="true" :noDefaultTime="true"
                          :label="'Time'" v-model="item.startTime" :showCopyPasteIcon="true" :initTime="item.startTime"
                          class="al-r pt-1" :ampmFormat="true" :hideDate="true" />
                      </div>
                      <div>
                        <div>Out</div>
                        <DateTimeTextField :hideCalenderIcon="true" :showCopyPasteIcon="true" :clearable="true"
                          :noDefaultTime="true" :label="'Time'" v-model="item.endTime" :initTime="item.endTime"
                          class="al-r pt-1" :ampmFormat="true" :hideDate="true" />
                      </div> -->
                    </v-flex>
                  </v-layout>
                </v-card-text>

              </v-card>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-container>
    <CardActions v-if="!loading" name="employeeUpdate" @submit="submit" :disabled="loadingBtn" :loading="loadingBtn"
      :update="true" @cancel="cancel" />
    <ChangePinDialog :dialog="setPinDialog" @close="setPinDialog = false" @submit="pinSubmit" />
  </div>
</template>

<script>
// import { mapActions } from "vuex";
import publicService from "@/api/public";
import terminalApi from "@/api/terminal"; // path to file
import employeeService from "@/modules/Employee/service.js";
import ImageBox from "@/components/Image/ImageBox.vue";
import locationService from "@/modules/Location/service.js";
import DateTimeTextField from '@/components/DateTimeTextField.vue';

const { validationMixin } = require("vuelidate");
const { required, maxLength, minLength } = require("vuelidate/lib/validators");
import defaultAccess from "@/modules/Employee/components/access";
import ChangePinDialog from "@/modules/Employee/components/ChangePin.vue";
import DepartmentService from "@/modules/Department/service.js";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "employee-edit",
  components: {
    ImageBox,
    DateTimeTextField,
    ChangePinDialog
  },
  data() {
    return {
      loadingBtn: false,
      employees: [],
      departments: [],
      subscription: null,
      employeeCountAllow: 0,
      setPinDialog: false,
      totalAttendees: 0,
      loading: false,
      States: [],
      Countries: [],
      location: {
        Address: {
          StateId: null,
          CountryCode: null,
        },
      },
      defaultCountryCode: 840,
      moreInfo: true,
      showPassword: false,
      access: {},
      fromList: false,
      employee: {
        firstName: null,
        lastName: null,
        imageURL: null,
        phoneNumber: null,
        email: null,
        hourlyRate: null,
        payOverTime: false,
        overTimeRate: 0,
        startOverTime: 40,
        pinCode: null,
        restrictedTime: false,
        timeRestrictions: [
          {
            id: 'Monday',
            startTime: null,
            endTime: null,
          },
          {
            id: 'Tuesday',
            startTime: null,
            endTime: null,
          },
          {
            id: 'Wednesday',
            startTime: null,
            endTime: null,
          },
          {
            id: 'Thursday',
            startTime: null,
            endTime: null,
          },
          {
            id: 'Friday',
            startTime: null,
            endTime: null,
          },
          {
            id: 'Saturday',
            startTime: null,
            endTime: null,
          },
          {
            id: 'Sunday',
            startTime: null,
            endTime: null,
          }
        ],
        metadata: {
          timeClockLogin: {
            clockInGracePeriod: 0,
            access: {
              onlyViewEmployee: [],
            },
          },
        },
      },
    };
  },
  watch: {
    'employee.payOverTime'(newVal) {
      this.payOverTime(newVal);
    }
  },
  created() {
    this.access = defaultAccess;
    this.getAll();
    this.loadSubscription();
    this.loademployee();
    this.getDepartments();

    publicService.States().then((response) => {
      this.States = response.data;
    });

    publicService.Country().then((response) => {
      this.Countries = response.data;
    });

    return terminalApi
      .Api()
      .get("settings/all")
      .then((response) => {
        this.location = response.data.data;
        localStorage.setItem(
          `${process.env.VUE_APP_STORAGE_PREFIX}location`,
          JSON.stringify(response.data.data)
        );
      });
  },
  computed: {
    ...mapGetters('employee', ['currentEmployee']),
    pinCodeErrors() {
      const errors = [];
      if (!this.$v.employee.pinCode.$dirty) return errors;
      if (!this.$v.employee.pinCode.required) errors.push("Field Is Required");
      if (!this.$v.employee.pinCode.minLength)
        errors.push("Pin must have 4 characters.");
      if (!this.$v.employee.pinCode.maxLength)
        errors.push("Pin must have only 4 characters.");
      return errors;
    },
    firstNameErrors() {
      const errors = [];
      if (!this.$v.employee.firstName.$dirty) return errors;
      if (!this.$v.employee.firstName.required)
        errors.push("Field Is Required");
      if (!this.$v.employee.firstName.minLength)
        errors.push("Field must be at least 2 characters long");
      return errors;
    },
  },
  methods: {
    ...mapActions("employee", ["setEmployee"]),
    payOverTime(val) {
      console.log('value', val)
      if (val) {
        this.employee.overTimeRate = this.employee.hourlyRate * 1.5; // Overtime is 1.5x regular rate
        this.employee.startOverTime = 40;
      } else {
        this.employee.overTimeRate = null;
        this.employee.startOverTime = 40;
      }
    },
    getDepartments() {
      DepartmentService
        .getAll({
          limit: 100,
        })
        .then((response) => {
          console.log("response", response);
          this.departments = response.data;
        })
        .catch((error) => {
          throw error;
        });
    },
    CopyOnAll(id) {
      return this.$swal
        .fire({
          title: "Are you sure?",
          text: `You want to copy ${id} time to all other days?`,
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Yes",
          cancelButtonText: "No",
        })
        .then((result) => {
          if (result.isConfirmed) {
            console.log('doing ')
            this.updateToAllDays(id)
            this.$forceUpdate();
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    updateToAllDays(dayId) {
      // Find the day object with the given id
      // console.log('timeRestrictions', this.timeRestrictions)
      const dayToCopyFrom = this.employee.timeRestrictions.find(day => day.id === dayId);



      if (dayToCopyFrom) {
        const { startTime, endTime } = dayToCopyFrom;

        // Create a new array with updated items
        this.employee.timeRestrictions = this.employee.timeRestrictions.map(day => {
          if (day.id !== dayId) {
            return {
              ...day,
              startTime,
              endTime
            };
          }
          return day;
        });
      } else {
        console.log(`No valid time restrictions found for ${dayId}`);
      }

      // return timeRestrictions;
    },
    loadSubscription() {
      const location = JSON.parse(
        localStorage.getItem(`${process.env.VUE_APP_STORAGE_PREFIX}location`)
      );
      // console.log("location", location);
      if (location) {
        return locationService
          .getSubscription(location.id)
          .then(async (response) => {
            // console.log("sub", response.data);
            this.subscription = response.data;
            if (this.subscription) {
              let total = 0;
              this.subscription.items.data.map((row) => {
                if (row.price.metadata && row.price.metadata.employeeCount) {
                  // console.log("row", row.price.metadata);
                  total +=
                    parseInt(row.price.metadata.employeeCount) * row.quantity;
                }
              });
              // console.log("total ", total);
              if (total !== 0) {
                this.employeeCountAllow = total;
              }
              if (
                this.subscription.metadata &&
                this.subscription.metadata.allowEmployee
              ) {
                this.employeeCountAllow =
                  this.subscription.metadata.allowEmployee;
              }
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
    getAll() {
      let noCache = true;
      this.loading = true;
      return employeeService
        .getAll(
          {
            limit: this.limit,
            offset: this.offset,
            local: true,
            noPagination: true,
            search: this.search,
          },
          noCache
        )
        .then((response) => {
          console.log("response all employees", response);
          this.employees = response.data;
          this.count = response.count;
          if (this.employees) {
            this.employees.map((e) => {
              if (
                e.metadata &&
                e.metadata.timeClockLogin &&
                e.metadata.timeClockLogin.employee
              ) {
                this.totalAttendees++;
              }
              // this.totalAttendees
            });
          }
          this.loading = false;
          return response;
        })
        .catch((error) => {
          this.loading = false;
          throw error;
        });
    },
    loademployee() {
      this.loading = true;
      console.log("this.$route.params", this.$route.params);
      if (!this.$route.params || !this.$route.params.id)
        return this.$router.go(-1);
      // just to avoid setting employee to store if its coming from list
      if (this.$route.params.fromList) this.fromList = true;
      const id = this.$route.params.id;
      this.$Progress.start();
      employeeService
        .getById(id)
        .then((response) => {
          console.log("response this employee", response);
          this.$Progress.finish();
          this.employee.id = response.data.id;
          this.employee.firstName = response.data.firstName;
          this.employee.lastName = response.data.lastName;
          this.employee.phoneNumber = response.data.phoneNumber;
          this.employee.pinCode = response.data.pinCode;
          this.employee.hourlyRate = response.data.hourlyRate;
          this.employee.payOverTime = response.data.payOverTime;
          this.employee.overTimeRate = response.data.overTimeRate;
          this.employee.startOverTime = response.data.startOverTime;
          this.employee.imageURL = response.data.imageURL;
          this.employee.owner = response.data.owner;
          this.employee.restrictedTime = response.data.restrictedTime;
          this.employee.DepartmentId = response.data.DepartmentId;

          if (response.data.timeRestrictions) {
            this.employee.timeRestrictions = response.data.timeRestrictions;
          }
          this.loading = false;
          if (response.data.metadata) {
            console.log("in metadata");
            this.employee.metadata = response.data.metadata;
            if (!this.employee.metadata.timeClockLogin) {
              this.employee.metadata.timeClockLogin = {
                admin: false,
                employee: false,
              };
            }
            if (
              this.employee.metadata.timeClockLogin &&
              this.employee.metadata.timeClockLogin.access
            ) {
              console.log("in hjere");
              this.employee.metadata.timeClockLogin.access = {
                ...this.access,
                ...this.employee.metadata.timeClockLogin.access,
              };
            } else {
              this.employee.metadata.timeClockLogin.access = this.access
            }
          } else {
            console.log("non here");
            this.employee.metadata = {
              isDriver: false,
              isTechnician: false,
              timeClockLogin: {
                admin: false,
                employee: false,
                access: this.access,
              },
            };
          }
          // todo: support more than one address
          console.log("metadata", this.employee.metadata);
          // this.employee.metadata = {
          //   ...this.defaultAccess,
          //   ...this.employee.metadata,
          //   ...response.data.metadata,
          // };
          this.employee.Address = response.data.Address || {};
          // console.log("employee metadata", this.employee.metadata);
        })
        .catch((error) => {
          this.loading = false;
          throw error;
        });
    },
    setPinOpen() {
      this.setPinDialog = true
    },
    pinSubmit(val) {
      this.employee.pinCode = val;
      this.setPinDialog = false
      this.submit()
    },
    submit() {
      // if (this.employeeCountAllow < this.totalAttendees) {
      //   this.$swal({
      //     title: "Limit Reach",
      //     text: `You have subscription for ${this.employeeCountAllow} and you already got ${this.totalAttendees} remove unused employee and add new one or add more attendess to your subscription`,
      //   });
      //   return false;
      // }

      console.log("this.employee", this.employee);
      this.loadingBtn = true;
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.$toast.error("Missing Fields", { timeout: 2000 });
        this.loadingBtn = false;
      } else {
        this.$Progress.start();
        employeeService
          .update(this.employee.id, this.employee)
          .then((res) => {
            console.log("resresresresres", res);
            if (res.data[1].length && !this.fromList) {
              this.setEmployee(res.data[1][0]);
            }
            this.$toast.success("Employee Updated", { timeout: 2000 });
            this.$Progress.finish();
            this.close();
            this.loadingBtn = false;
          })
          .catch((err) => {
            console.log(err);
            this.loadingBtn = false;
            this.$toast.error(err.data ? err.data.message : "Error", {
              timeout: 2000,
            });
            this.$Progress.fail();
          });
      }
    },
    cancel() {
      this.close();
    },
    close() {
      return this.$router.go(-1);
    },
    getImages() {
      return this.images;
    },
    setImage(val) {
      this.employee.imageURL = val;
    },
  },
  mixins: [validationMixin],
  validations: {
    employee: {
      pinCode: {
        required,
        minLength: minLength(4),
        maxLength: maxLength(4),
      },
      firstName: {
        required,
        minLength: minLength(2),
      },
    },
  },
};
</script>

<style scoped>
.touch-view-container {
  height: calc(100vh - 170px);
  width: 100%;
  overflow: auto;
}
</style>
